import React from "react";
import NavBar from "../components/homePage/navBar";
import Inventories from "../components/Inventories/Inventories";

const InventoriesPage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <Inventories />
        </div>
    )
}

export default InventoriesPage;